import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable, Subject } from 'rxjs';

export interface CalendarPreview {
  start_date: DateTime;
  end_date: DateTime;
  title?: string;
}

@Injectable({ providedIn: 'root' })
export class EventsChangeNotifier {
  private _changes$: Subject<void> = new Subject<void>();

  private _preview$: Subject<CalendarPreview> = new Subject<CalendarPreview>();

  get changes$(): Observable<void> {
    return this._changes$;
  }

  get preview$(): Observable<CalendarPreview> {
    return this._preview$;
  }

  notifyEventsChanged() {
    this._changes$.next();
  }

  notifyPreviewChanged(
    start_date: DateTime,
    end_date: DateTime,
    title?: string
  ) {
    this._preview$.next({ start_date, end_date, title });
  }
}
